
import debounce from 'lodash.debounce';
import $ from 'jquery';

const $priceFields = $( '.wcpa_select_ticket' );
const ticketIcon = '<svg class="svgIcon svgIcon--ticketPreviewBtn" viewBox="0 0 41 34" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C2.23858 0 0 2.23858 0 5V29C0 31.7614 2.23858 34 5 34H36C38.7614 34 41 31.7614 41 29V5C41 2.23858 38.7614 0 36 0H5ZM26.0791 10.6018C27.1462 10.6018 28.0267 9.74409 28.0267 8.70455V6.89727C28.0267 5.85773 27.1462 5 26.0791 5H14.9476C13.8805 5 13 5.85773 13 6.89727V8.70455C13 9.74409 13.8805 10.6018 14.9476 10.6018H26.0791Z"/></svg>';

function handleChange() {
	$priceFields.each( function () { // eslint-disable-line func-names
		const value = $( this ).val() ? $( this ).val() : 0;

		const priceData = JSON.parse( $( this ).find( 'option[data-price]:first' ).attr( 'data-price' ) );
		const customPrice = $( this ).closest( '.wcpa_row' ).next( '.wcpa_row' ).find( 'input:checked' ).val();
		const price = priceData.pricingType === 'custom' ? customPrice : priceData.value;
		const totalInt = parseInt( value, 10 ) * parseFloat( price );

		const name = $( this ).closest( '.wcpa_row' ).find( 'label' ).text();

		// Make a class from the label for attribute.
		const itemClass = $( this ).closest( '.wcpa_row' ).find( 'label' ).attr( 'for' )
			.replace( 'select', 'item' );

		if ( value > '0' ) {
			const $conditionalParent = $( this ).closest( '.wcpa_row' ).prev( '.wcpa_row' ).find( '.wcpa_has_relation' );

			if ( $conditionalParent.length ) {
				if ( !$conditionalParent.find( 'input:checkbox:checked' ).length ) {
					$( `.${itemClass}` ).remove();
					return;
				}
			}

			const message = `${value} x ${name} <br> $${totalInt.toFixed( 2 )}`;
			if ( $( `.${itemClass}` ).length === 0 ) {
				$( `<p class="${itemClass}">${message}</p>` ).insertBefore( '.ticketPreview-action' );
			} else {
				$( `.${itemClass}` ).html( message );
			}
		} else {
			$( `.${itemClass}` ).remove();
		}

		// Toggle ticketPreview if it has children.
		$( '.ticketPreview' ).toggleClass( 'is-open', $( '.ticketPreview' ).children().not( '.ticketPreview-action' ).length > 0 );
	} );
}

function handleInlineAddonChange() {
	const value = $( this ).val();
	const name = $( this ).closest( '.wcpa_addon_inline' ).find( 'label' ).text();
	const nameWithoutPrice = name.slice( 0, name.length - 9 );
	const itemClass = $( this ).closest( '.wcpa_row' ).find( 'label' ).attr( 'for' )
		.replace( 'select', 'item' );
	const message = `${nameWithoutPrice} <br> $${value}`;
	const noTicketPreview = $( this ).closest( '.wcpa_addon_inline_parent' ).hasClass( 'wcpa_no_ticket_preview' );

	if ( $( this ).is( ':checked' ) && !noTicketPreview ) {
		if ( $( `.${itemClass}` ).length === 0 ) {
			$( `<p class="${itemClass}">${message}</p>` ).insertBefore( '.ticketPreview-action' );
		}
	} else {
		$( `.${itemClass}` ).remove();
	}

	$( '.ticketPreview' ).toggleClass( 'is-open', $( '.ticketPreview' ).children().not( '.ticketPreview-action' ).length > 0 );
}

function setOffset() {
	$( '.ticketPreview' ).css( 'margin-top', $( '.header' ).outerHeight() - 20 );
}

function initEvents() {
	$priceFields.on( 'change', handleChange );
	$( '.wcpa_has_relation' ).on( 'change', 'input', handleChange );
	$( '.wcpa_weekends input, .wcpa_holidays input' ).on( 'change', handleChange );
	$( '.wcpa_addon_inline input' ).on( 'change', handleInlineAddonChange );

	// Submit product.
	$( '.ticketPreview-submit' ).on( 'click', () => {
		$( 'button[name="add-to-cart"]' ).click();
	} );

	$( window ).on( 'resize', debounce( setOffset, 250 ) );
}

function init() {
	if ( $priceFields.length === 0 ) {
		return;
	}

	$( '.header' ).prepend( `<div class="ticketPreview ticketPreview--uppercase"><div class="ticketPreview-action"><button class="ticketPreview-submit">${ticketIcon}Add to crate</button></div></div>` );
	initEvents();
	setOffset();
}

export default {
	init,
};
